<div class="h-screen overflow-auto lg:px-16 py-8 bg-white grid md:grid-cols-2">
  <!-- left side -->
  <div class="relative hidden md:flex flex-col rounded-tl-3xl overflow-hidden">
    <img [src]="slides[currentIndex]?.image" alt="Feature Image"
      class="absolute top-0 left-0 z-0 w-full h-full object-cover transition-all duration-700 ease-in-out" />

    <div class="absolute z-10 top-0 left-0 w-full h-full bg-gradient-to-b from-black/10 via-black/50 to-black/75"></div>

    <div class="relative z-20 w-full grid grid-cols-2">
      <div class="rounded-tl-3xl relative">
        <div class="absolute top-0 right-0 notched-top-right"></div>
      </div>
      <div class="rounded-bl-3xl bg-white flex pl-3">
        <p
          class="text-primary text-sm font-medium hidden lg:flex items-center justify-center gap-2 rounded-full border border-primary ml-4 w-[96%] px-4 py-4 mx-auto">
          <i class="fas fa-newspaper text-[#1A4A9C]"></i>
          <span>Digital Publishing Management System</span>
        </p>
      </div>
    </div>
    <div class="relative z-20 flex-1 col-span-full w-full flex flex-col px-16">
      <div class="absolute top-0 right-0 notched-top-right"></div>
      <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>

      <div class="flex flex-col mt-auto mb-[2%]">
        <div class="text-2xl font-sans text-white mt-auto py-8 text-left w-[60%]">
          {{ slides[currentIndex]?.text }}
        </div>
        <!-- Features List -->
        <div class="space-y-2 mb-6">
          <div class="flex items-center gap-3 text-sm text-white">
            <div class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Manage newspapers & magazines</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Digital book library system</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Real-time publishing tools</span>
          </div>
        </div>
      </div>
    </div>

    <!-- lower action buttons -->
    <div class="w-full flex relative z-20">
      <div class="absolute top-0 left-0 notched-top-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
      <div class="absolute top-0 right-0 notched-top-right"></div>
      <div class="rounded-tr-3xl pt-3 pb-2 pr-3 bg-white">
        <button (click)="prev()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="flex-1 h-full relative flex justify-center">
        <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
        <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
        <div class="flex space-x-3 mt-8">
          <div *ngFor="let slide of slides; let i = index"
            class="cursor-pointer transition-all duration-300 rounded-full !h-3" [ngClass]="{
              'w-8  bg-primary-200 ': i === currentIndex,
              'w-3  bg-white  hover:bg-white/80': i !== currentIndex
            }"></div>
        </div>
      </div>
      <div class="rounded-tl-3xl pt-3 pb-2 pl-3 bg-white">
        <button (click)="next()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- right-side -->
  <div class="relative overflow-hidden lg:mr-16">
    <!-- Floating Icons for ePaper Theme -->
    <div class="absolute top-36 left-20 text-[#03406C]/10 text-3xl animate-float">
      <i class="fas fa-newspaper"></i>
    </div>
    <div class="absolute top-40 right-32 text-[#03406C]/10 text-3xl animate-float-delayed">
      <i class="fas fa-book-open"></i>
    </div>
    <div class="absolute bottom-32 left-40 text-[#03406C]/10 text-4xl animate-float">
      <i class="fas fa-scroll"></i>
    </div>
    <div class="absolute bottom-20 right-20 text-[#03406C]/10 text-3xl animate-float-delayed">
      <i class="fas fa-feather-alt"></i>
    </div>

    <!-- Main Content Container -->
    <div class="relative z-20 flex flex-col justify-center items-center h-full lg:ml-16">
      <!-- Logo & Emblem Section -->
      <div class="flex justify-center items-center gap-4 animate-fadeIn w-full mb-6">
        <img src="assets/images/tsn.png" class="w-16 h-16" alt="tsn Emblem" />
      </div>

      <!-- Title -->
      <div class="mb-6 text-center">
        <h2 class="!text-4xl !font-semibold text-[#1A4A9C] !my-0 mb-1">
          Change Password
        </h2>
        <p class="text-lg text-gray-500">
          Update your account password
        </p>
      </div>

      <form [formGroup]="form" (ngSubmit)="changePassword()" autocomplete="off" novalidate
        class="w-full flex flex-col items-center">

        <!-- Current Password -->
        <div class="mb-4 relative w-[500px]">
          <input 
            [type]="showOldPassword ? 'text' : 'password'" 
            formControlName="oldPassword" 
            placeholder="Current Password"
            class="w-full h-[50px] rounded-[40px] border px-4 pr-12 focus:outline-none focus:ring-2 transition-all"
            [class.border-red-500]="oldPassword?.invalid && oldPassword?.touched"
            [class.border-gray-300]="!oldPassword?.invalid || !oldPassword?.touched"
            [class.focus:ring-blue-500]="!oldPassword?.invalid || !oldPassword?.touched"
            [class.focus:ring-red-200]="oldPassword?.invalid && oldPassword?.touched" />
          
          <button 
            type="button"
            class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 h-[50px] w-[40px] flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            (click)="toggleShowPassword('old')">
            <mat-icon class="text-gray-600">{{ showOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <!-- Old Password Error Messages -->
          <div *ngIf="oldPassword?.invalid && oldPassword?.touched" class="absolute left-4 -bottom-5">
            <p *ngIf="oldPassword?.errors?.['required']" class="text-xs text-red-600">
              Current password is required
            </p>
          </div>
        </div>

        <!-- Spacing for error message -->
        <div class="h-6"></div>

        <!-- New Password -->
        <div class="mb-4 relative w-[500px]">
          <input 
            [type]="showPassword ? 'text' : 'password'" 
            formControlName="newPassword" 
            placeholder="New Password"
            class="w-full h-[50px] rounded-[40px] border px-4 pr-12 focus:outline-none focus:ring-2 transition-all"
            [class.border-red-500]="newPassword?.invalid && newPassword?.touched"
            [class.border-gray-300]="!newPassword?.invalid || !newPassword?.touched"
            [class.focus:ring-blue-500]="!newPassword?.invalid || !newPassword?.touched"
            [class.focus:ring-red-200]="newPassword?.invalid && newPassword?.touched" />
          
          <button 
            type="button"
            class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 h-[50px] w-[40px] flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            (click)="toggleShowPassword('new')">
            <mat-icon class="text-gray-600">{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <!-- New Password Error Messages -->
          <div *ngIf="newPassword?.invalid && newPassword?.touched" class="absolute left-4 -bottom-5">
            <p *ngIf="newPassword?.errors?.['required']" class="text-xs text-red-600">
              New password is required
            </p>
            <p *ngIf="newPassword?.errors?.['minlength']" class="text-xs text-red-600">
              Password must be at least 8 characters
            </p>
          </div>
        </div>

        <!-- Spacing for error message -->
        <div class="h-6"></div>

        <!-- Confirm Password -->
        <div class="mb-4 relative w-[500px]">
          <input 
            [type]="showConfirmPassword ? 'text' : 'password'" 
            formControlName="confirmPassword"
            placeholder="Confirm New Password"
            class="w-full h-[50px] rounded-[40px] border px-4 pr-12 focus:outline-none focus:ring-2 transition-all"
            [class.border-red-500]="(confirmPassword?.invalid || form.hasError('passwordsMismatch')) && confirmPassword?.touched"
            [class.border-gray-300]="(!confirmPassword?.invalid && !form.hasError('passwordsMismatch')) || !confirmPassword?.touched"
            [class.focus:ring-blue-500]="(!confirmPassword?.invalid && !form.hasError('passwordsMismatch')) || !confirmPassword?.touched"
            [class.focus:ring-red-200]="(confirmPassword?.invalid || form.hasError('passwordsMismatch')) && confirmPassword?.touched" />
          
          <button 
            type="button"
            class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 h-[50px] w-[40px] flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            (click)="toggleShowPassword('confirm')">
            <mat-icon class="text-gray-600">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <!-- Confirm Password Error Messages -->
          <div *ngIf="confirmPassword?.touched" class="absolute left-4 -bottom-5">
            <p *ngIf="confirmPassword?.errors?.['required']" class="text-xs text-red-600">
              Please confirm your password
            </p>
            <p *ngIf="form.hasError('passwordsMismatch') && !confirmPassword?.errors?.['required']" 
               class="text-xs text-red-600">
              Passwords do not match
            </p>
          </div>
        </div>

        <!-- Spacing for error message -->
        <div class="h-6"></div>

        <!-- Password Requirements Box -->
        <div class="w-[500px] mb-6 bg-blue-50 rounded-3xl p-4 border border-blue-100">
          <p class="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <i class="fas fa-info-circle text-blue-600"></i>
            Password Requirements:
          </p>
          <ul class="text-xs text-gray-600 space-y-1.5 ml-6">
            <li class="flex items-center gap-2">
              <i class="fas fa-check-circle" 
                 [class.text-green-600]="newPassword?.value?.length >= 8"
                 [class.text-gray-400]="!newPassword?.value || newPassword?.value?.length < 8"></i>
              At least 8 characters long
            </li>
            <li class="flex items-center gap-2">
              <i class="fas fa-check-circle" 
                 [class.text-green-600]="!form.hasError('passwordsMismatch') && confirmPassword?.value"
                 [class.text-gray-400]="form.hasError('passwordsMismatch') || !confirmPassword?.value"></i>
              Both passwords must match
            </li>
            <li class="flex items-center gap-2">
              <i class="fas fa-check-circle" 
                 [class.text-green-600]="oldPassword?.value"
                 [class.text-gray-400]="!oldPassword?.value"></i>
              Current password is required
            </li>
          </ul>
        </div>

        <!-- Change Password Button -->
        <button 
          type="submit" 
          [disabled]="form.invalid || loading" 
          class="w-[500px] h-[50px] rounded-[40px] text-white font-semibold 
                 bg-gradient-to-r from-[#124B99] via-[#509EE3] to-[#03406C] 
                 shadow-lg hover:brightness-110 hover:shadow-xl transition-all
                 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:brightness-100
                 flex items-center justify-center gap-2">
          <mat-spinner *ngIf="loading" diameter="20" class="inline-block"></mat-spinner>
          <span>{{ loading ? 'Changing Password...' : 'Change Password' }}</span>
        </button>

        <!-- Cancel Button -->
        <button 
          type="button"
          (click)="cancel()"
          [disabled]="loading"
          class="mt-4 w-[500px] h-[50px] rounded-[40px] font-semibold 
                 border-2 border-[#1A4A9C] text-[#1A4A9C]
                 hover:bg-[#1A4A9C] hover:text-white transition-all
                 disabled:opacity-50 disabled:cursor-not-allowed">
          Cancel
        </button>

        <!-- Back to Dashboard -->
        <div class="mt-6">
          <a routerLink="/dashboard" 
             class="text-[#1A4A9C] hover:text-[#124B99] font-semibold text-sm 
                    inline-flex items-center gap-1 transition-colors">
            <mat-icon class="text-sm">arrow_back</mat-icon>
            Back to Dashboard
          </a>
        </div>

      </form>

      <!-- Footer -->
      <div class="mt-8 text-center space-y-4">
        <!-- Copyright -->
        <p class="text-sm text-gray-600 font-medium">
          © 2025 RIDC - Research and Innovation Development Center
        </p>

        <!-- Social Media Icons -->
        <div class="flex gap-3 justify-center">
          <a href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-[#1A4A9C] hover:border-[#1A4A9C] hover:text-white transition-all group shadow-sm hover:shadow-md">
            <i class="fab fa-instagram text-[#03406C] text-base group-hover:text-white transition-colors"></i>
          </a>
          <a href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-400 hover:border-blue-400 hover:text-white transition-all group shadow-sm hover:shadow-md">
            <i class="fab fa-twitter text-[#03406C] text-base group-hover:text-white transition-colors"></i>
          </a>
          <a href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all group shadow-sm hover:shadow-md">
            <i class="fab fa-facebook-f text-[#03406C] text-base group-hover:text-white transition-colors"></i>
          </a>
          <a href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-red-600 hover:border-red-600 hover:text-white transition-all group shadow-sm hover:shadow-md">
            <i class="fab fa-youtube text-[#03406C] text-base group-hover:text-white transition-colors"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>